import api from '@/services';

export const apiTwinShowroom = async (payload) => {
  return await api.get('/twin/showroom', { params: payload });
};
export const apiSubscribedTwins = async () => {
  return await api.get('/user/subscribed-twin');
};
export const apiCancelSubscription = async (payload) => {
  return api.post('/payment/stripe/cancel-subscription', payload);
};
export const apiFeaturedTrendingTwins = async () => {
  return api.get('/twin/top-featured');
};

export const apiCreateTwin = async (formData: FormData) => {
  return await api.post('/user/my-twin/request', formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const apiGetTwinDetails = async () => {
  return await api.get('/user/my-twin/details');
};
export const apiUpdateMyTwinDetails = async (formData: FormData) => {
  return await api.patch('/user/my-twin/update', formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const apiUpdateMyTwinAudio = async (formData: FormData) => {
  return await api.patch('/user/my-twin/update', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const apiFetchTwinAnalytics = async () => {
  return await api.get('/user/my-twin/analytics');
};
export const apiCreateTopic = async (formData: FormData) => {
  return await api.post('/user/my-twin/create-category', formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const apiDeleteTopic = async ({
  brainId,
  fileCode,
}: {
  brainId: string;
  fileCode: string;
}) => {
  return await api.delete('/user/my-twin/files', {
    params: { brainId, fileCode },
  });
};

export const apiSearchAssociatedTwins = async () => {
  return await api.get('/user/my-twin/associated-twins');
};

export const apiSetDefaultTwin = async (payload: { twinId: string }) => {
  return await api.post('/user/my-twin/default', payload);
};

export const apifetchTwinPackages = async () => {
  return await api.get('/user/my-twin/packages');
};

export const apiDeleteAvatar = async (payload: {
  imageAvatarId?: string;
  videoAvatarId?: string;
}) => {
  return await api.delete('/user/my-twin/avatar', { params: payload });
};

export const apiFetchUserTwinPlan = async () => {
  return await api.get('/user/my-twin/policy');
};

export const apiCheckTwinId = async (payload: { name: string }) => {
  return await api.post('/user/my-twin/name-availability', payload);
};

export const apiGetPresignedS3Url = async (payload: {
  fileData: { fileName: string; fileType: string; fileSize: number };
}) => {
  return await api.post('/user/my-twin/generate-presigned-url', payload);
};

export const getTwinRecentInteractions = async () => {
  return await api.get('/user/my-twin/interactions');
};

export const getDownloadTwinChatHistory = async ({
  duration,
  id,
}: {
  duration: number;
  id: string;
}) => {
  return await api.get('/user/my-twin/download-history', {
    params: { duration, id },
    responseType: 'blob',
  });
};

export const apiGetUserFiles = async (payload: {
  vaultId: string;
  query: string;
}) => {
  return await api.get('/user/my-twin/search-files', {
    params: payload
  });
};
